import { SxProps } from "@mui/material";

export const sxLabel: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 600,
}

export const sxInput: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 400,
    fontSize: '14px'
}

export const sxError: SxProps = {
    color: '#D84141',
    fontSize: '12px'
}

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
}

export const sxErrorButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    backgroundColor: '#D84141',

    '&:hover.MuiButton-contained': {
        backgroundColor: '#6b1a2f',
    }
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '481px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px 48px',
    gap: '24px',
}

export const sxOutlinedButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px '
}